import joinUrl from "../../utils/join-url";
import requestUtility from "../../helpers/request-utility";

const updateBillingProfile = (apiUrl) => (id, data) => {
  const url = joinUrl(apiUrl, `/checkoutservice/pb/billing-profiles/${id}/`);
  return requestUtility.put(url, data);
};

export default updateBillingProfile;
